import React from 'react';
import { instanceOf } from 'prop-types';
import { connect } from 'react-redux';

const Summary = ({ surveyInfo }) => {
  const {
    surveyName,
    categoryName,
    study,
    targetingCriteria,
    noOfQuestions = 0,
    requiredCompletes,
    incidenceRate,
  } = surveyInfo;
  return (
    <div className="ie--summary--data">
      <h3 className="ie--summary--heading">{surveyName}</h3>
      <div className="ie--summary--body">
        <div className="ie--summary--label">Category:</div>
        <div className="ie--summary--value">{categoryName}</div>

        <div className="ie--summary--label">Study:</div>
        <div className="ie--summary--value">{study.sd}</div>

        <div className="ie--summary--label">Target:</div>
        <div className="ie--summary--value">{targetingCriteria || 'ADULT18+'}</div>

        <div className="ie--summary--label"># of Questions:</div>
        <div className="ie--summary--value">{noOfQuestions || 0}</div>

        <div className="ie--summary--label">Estimated Incidence Rate:</div>
        <div className="ie--summary--value">
          {incidenceRate ? Math.round(incidenceRate) : 0}%{' '}
        </div>

        <div className="ie--summary--label">Sample Size (# of Completes):</div>
        <div className="ie--summary--value">{requiredCompletes || 0}</div>
      </div>
    </div>
  );
};


Summary.propTypes = {
  surveyInfo: instanceOf(Object),
};


const mapStateToProps = ({ turnkeyOmnibus }) => {
  const { surveyInfo } = turnkeyOmnibus;
  return {
    surveyInfo,
  };
};

export default connect(
  mapStateToProps,
  null
)(Summary);
